var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live-sales-data"},[_c('div',{staticClass:"data-title"},[_vm._v("直播销售情况")]),_c('div',{staticClass:"data-value"},[_vm._v(_vm._s(_vm.liveData.sales))]),_c('div',{staticClass:"data-sales"},[_c('span',[_vm._v("销量(件)")]),_vm._v(" "+_vm._s(_vm.liveData.order_num))])])
}
var staticRenderFns = []

export { render, staticRenderFns }